import React from 'react';
import musicUrl from '../../utilities/musicUrl';

export default function Song({ name, url }) {

    return(
        <div className="song" id={name}>
            <span>{name}</span>
            <audio src={musicUrl(url)} controls></audio>    
        </div>    
    );
}
